import React from 'react';
import { Typography } from 'antd';

const { Paragraph, Text } = Typography;

/**
 * 관련주 설명 문자열을 포매팅하는 함수
 * - '###'를 기준으로 내용을 분리합니다.
 * - '[숫자]' 형태의 주석을 제거합니다.
 * - 각 섹션의 제목('->'를 '→'로 변경)과 내용을 분리하여 보여줍니다.
 * @param {string} reason - 포매팅할 원본 문자열
 * @returns {JSX.Element|string} 포매팅된 React 엘리먼트 또는 기본 메시지
 */
export const formatStockReason = (reason) => {
  // reason이 없거나 유효하지 않은 경우 기본 메시지를 반환합니다.
  if (!reason || typeof reason !== 'string') {
    return <Paragraph>상세 설명 없음</Paragraph>;
  }

  // 1. '[숫자 숫자]' 형태의 주석을 정규표현식으로 모두 제거합니다.
  const cleanedReason = reason.replace(/\s*\[[\d\s]+\]/g, '');

  // 2. '###'를 기준으로 문자열을 분리하고, 각 부분의 앞뒤 공백을 제거합니다.
  const sections = cleanedReason.split('###').map(s => s.trim()).filter(Boolean);

  // 3. 분리된 각 섹션을 JSX로 변환합니다.
  return (
    <div>
      {sections.map((section, index) => {
        const titleMatch = section.match(/^(.*?:\s*)/);
        const title = titleMatch ? titleMatch[1] : '';
        const content = title ? section.substring(title.length) : section;

        // [변경점 1] -> 를 예쁜 화살표 → 로 변경합니다.
        const displayTitle = title.replace('->', '→');

        return (
          // [변경점 2] 각 섹션을 div로 감싸고 제목(Text)과 내용(Paragraph)을 분리합니다.
          // Paragraph는 블록 요소이므로 자동으로 다음 줄에 표시됩니다.
          <div key={index} style={{ marginBottom: index === sections.length - 1 ? 0 : '0.75rem' }}>
            {displayTitle && <Text strong>{displayTitle}</Text>}
            <Paragraph style={{ margin: '0.25rem 0 0 0' }}>
              {content}
            </Paragraph>
          </div>
        );
      })}
    </div>
  );
};